<div id="serpentine-timeline" style="width: 100%; height: 500px"></div>
